import { createSimpleFunctional } from '../../util/helpers';
import VCard from './VCard';
import VCardMedia from './VCardMedia';
import VCardTitle from './VCardTitle';

export { VCard, VCardMedia, VCardTitle };

VCard.install = function install(Vue) {
  var VCardActions = createSimpleFunctional('card__actions');
  var VCardText = createSimpleFunctional('card__text');

  Vue.component(VCard.name, VCard);
  Vue.component(VCardMedia.name, VCardMedia);
  Vue.component(VCardTitle.name, VCardTitle);
  Vue.component('v-card-actions', VCardActions);
  Vue.component('v-card-text', VCardText);
};

export default VCard;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VCard/index.js
// module id = f/u0
// module chunks = 0